<template>
 <div v-if="currItems && currItems.length > 0" class="m-screening-box">
    <div class="m-select-box">
      <div class="m-select-items__container">
        <div @click="() => toogleOpen(item.key)" v-for="item in items" :key="item.key" class="m-select-items" :class="{'m-select-items--active': item.open}">{{item.name}}<img src="../assets/main/right-arrow.png" alt="">
        </div>
        <!-- <div class="m-select-items">组织机构类型 <img src="../assets/main/right-arrow.png" alt=""></div> -->
      </div>
      <div v-if="openItemBox.length > 0" class="select-pop-box">
          <div v-for="(box, boxIndex) in openItemBox" :key="box.key + boxIndex" class="new-infrastructure-box">
            <h2 v-if="box.title">{{box.title}}</h2>
            <div v-if="box && box.list && box.list.length > 0" class="select-list">

                <div v-for="(boxListItem, boxListItemIndex) in box.list" :key="boxListItem.key + boxListItemIndex" class="select-items">
                  <h3 v-if="boxListItem.title">{{boxListItem.title}}</h3>
                  <div v-if="boxListItem.items && boxListItem.items.length > 0" class="checkbox-list">
                      <label v-for="(item, itemIndex) in boxListItem.items" :key="item.key + itemIndex + item.active">
                        <template v-if="item.active">
                          <input checked="checked" @change="(e) => onChecked(item, e)" type="checkbox" name="">{{item.name}}
                        </template>
                        <template v-if="!item.active">
                          <input @change="(e) => onChecked(item, e)" type="checkbox" name="">{{item.name}}
                        </template>
                      </label>
                  </div>
                </div>
            </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: 'SearchCondition',
    props: {
        items: {
            type: Array,
            default: () => []
        },
        selectedKeys: {
            type: Array,
            default: () => []
        },
        activeItemKey: {
            type: String
        }
    },
    data() {
        return {
            currItems: []
        }
    },
    computed: {
        openItemKey() {
            const item = this.currItems.find((item) => {
                return item.open;
            });
            return item ? item.key : ''
        },
        openItemBox() {
            const item = this.currItems.find((item) => {
                return item.open;
            });
            return item ? item.box : []
        },
    },
    watch: {
        selectedKeys(n, o) {
            this.selectedKeys = n;
            this.init();
        },
        items(n, o) {
            console.log(n, '...')
            this.currItems = n;
            this.init();
        }
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            console.log('init',this.selectedKeys)
            const items = this.items || [];
            const selectedKeys = this.selectedKeys;
            this.currItems = items.map((item) => {
                if (item.box) {
                    item.box = item.box.map((itemBox) => {
                        if (itemBox.list) {
                            itemBox.list = itemBox.list.map((itemBoxList) => {
                                if (itemBoxList.items) {
                                    itemBoxList.items = itemBoxList.items.map((ite) => {
                                        const res = selectedKeys.find((keyItem) => {
                                            return keyItem.key === ite.key
                                        });
                                        ite.active = !!res
                                        if (ite.active) {
                                            console.log('ite---',ite)
                                            console.log(ite.name)
                                        }
                                        return ite
                                    })
                                }
                                return itemBoxList
                            })
                        }
                        return itemBox
                    })
                }
                /* if (this.activeItemKey === item.key) {
                    item.open = !item.open
                } else {
                    item.open = this.activeItemKey === item.key
                } */
                return item;
            })
            this.$forceUpdate();
        },
        toogleOpen(key) {
            this.$emit('activeItem', key)
        },
        onChecked(item, value) {
            const checked = value.target.checked
            /* const checked = value.target.checked
            if (checked && !this.selectedKeys.includes(key)) {
                this.selectedKeys.push(key)
            }
            if (!checked && this.selectedKeys.includes(key)) {
                this.selectedKeys.splice(this.selectedKeys.findIndex((item) => {
                    return item.key === key
                }), 1)
            } */
            console.log("key,item",value)
            this.$emit('onselected', item, checked)
        }
    },

};
</script>

<style scoped>
  @media screen and (max-width: 850px){
    .m-select-items__container {
        height: 60px;
    }
    .m-screening-box{
      display: block;
      /* height: .45rem; */
    }
    .consulting{width: .6rem;height: 2.4rem;font-size: .32rem;padding-top: .26rem;}
    .m-select-items{
        float: left;font-size: .24rem;color: #424141;
        /* width: 2rem; */
        position: relative;padding-left: .3rem;
    }
    .m-select-items--active {
      color: #0091FF;
    }
    .m-select-items img{transform: rotate(90deg);vertical-align: -1px;margin-left: .1rem;}
    .m-select-box{position: relative;}
    .select-pop-box{
      /* position: absolute; */
      width: 100%;
      overflow: hidden;
      background: #fff;box-sizing: border-box;left: 0;top: .8rem;z-index: 20;overflow-y: auto;
      height: 9rem;
      margin-bottom: 20px;
    }
    .select-pop-box h2{border-bottom: 1px solid #eee;line-height: 1rem;height: 1rem;text-align: center;color: #424141;font-weight: bold;font-size: .32rem;}
    .select-list{padding: 0 .3rem;}
    .select-list h3{font-size: .28rem;color: #646363;font-weight: bold;border-left: 3px solid #666;height: .3rem;line-height: .3rem;margin: .2rem 0;padding-left: .12rem;}
    .checkbox-list label{float: left;font-size: .28rem;color: #424141;padding-right: .5rem;line-height: .6rem;}
    .checkbox-list label input{width: .28rem;height: .28rem;vertical-align: middle;margin-right: .1rem;}
    .select-items{clear: both;margin-bottom: .3rem;overflow: hidden;}
  }
</style>
